import { useConfig } from 'components/ui';

/**
 * useThemeClass hook returns the theme classes based on the primary color level and theme color.
 *
 * @returns {object} - The theme classes.
 */
function useThemeClass() {
    const { themeColor, primaryColorLevel } = useConfig();
    const color = `${themeColor}-${primaryColorLevel}`;

    return {
        ringTheme: `ring-${color}`,
        borderTheme: `border-${color}`,
        bgTheme: `bg-${color}`,
        textTheme: `text-${color}`,
    };
}

export default useThemeClass;
